module.exports = __webpack_public_path__ + "static/media/hero1.a92d7773.jpg";